module.exports = __webpack_public_path__ + "static/media/cloud-sun-svgrepo-com.2a061c6a.svg";